export default __webpack_public_path__ + "static/media/cbh-animation.7c1fa09a.mp4";